var ProductReviews, Review,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Review = require('./review');

module.exports = ProductReviews = (function() {
  function ProductReviews(arg) {
    var productReviews;
    productReviews = arg.productReviews;
    this.fetchSuccess = bind(this.fetchSuccess, this);
    if ($('#partial-rendering-loader').is(':visible')) {
      return;
    }
    if (productReviews) {
      this.rootUrl = productReviews.rootUrl, this.locale = productReviews.locale;
    }
    if (!(this.rootUrl && this.locale)) {
      return;
    }
    this.fetchProductReviews();
  }

  ProductReviews.prototype.fetchProductReviews = function() {
    var csrf;
    this.deals = $('figure.deal-card[data-uuid], figure.deal-card-mini[data-uuid], .carousel-slide-deal[data-uuid]');
    if (this.deals.length) {
      csrf = $('meta[name=csrf-token]').attr('content');
      return $.ajax({
        url: this.rootUrl + "/product_review_proxy/products.json?locale=" + this.locale + "&_csrf=" + csrf,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(this.prepareData()),
        error: this.fetchError,
        success: this.fetchSuccess
      });
    }
  };

  ProductReviews.prototype.prepareData = function() {
    return {
      deal_uuid: this.extractDealUuids().join()
    };
  };

  ProductReviews.prototype.extractDealUuids = function() {
    var dealUuids;
    dealUuids = [];
    this.deals.each(function() {
      var uuid;
      uuid = $(this).data('uuid');
      if (uuid.length) {
        return dealUuids.push(uuid);
      }
    });
    return dealUuids;
  };

  ProductReviews.prototype.fetchError = function() {};

  ProductReviews.prototype.fetchSuccess = function(data) {
    var products;
    if (!(products = data.products)) {
      return;
    }
    return this.deals.each(function() {
      var $el, params, uuid;
      $el = $(this);
      uuid = $el.data('uuid');
      params = {
        $el: $el,
        data: products[uuid],
        uuid: uuid
      };
      if (params.data) {
        return (new Review(params)).render();
      }
    });
  };

  return ProductReviews;

})();

//# sourceMappingURL=data:application/json;base64,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
